import { FinanceFeesLayout } from "@modules/finances/components/financeFeesLayout"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"

export const useFinanceSidebar = () => {
  const { addSidebarStackOnTop } = useSidebar()

  const navigateToFinanceFeesLayout = () => {
    addSidebarStackOnTop({
      content: <FinanceFeesLayout />,
    })
  }

  return {
    navigateToFinanceFeesLayout,
  }
}
